import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import Logo from '../../../images/white_horizontal_logo.svg';

interface IProps {
  alt?: string;
  onClick?: (e?: React.MouseEvent<HTMLElement>) => void;
  role?: string;
}

const fadeInScale = keyframes`
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

export const Brand = (props: IProps): React.ReactElement => {
  const clickHandler = (e: React.MouseEvent): void => {
    if (props.onClick) {
      e.preventDefault();
      props.onClick();
    }
    return;
  };

  return (
    <BrandWrapper>
      <BrandLink href='/#' onClick={clickHandler}>
        <LogoImage src={Logo} alt={props.alt} />
      </BrandLink>
    </BrandWrapper>
  );
};

const BrandWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`;

const BrandLink = styled.a`
  animation: ${fadeInScale} 600ms ease-out;
  animation-fill-mode: both;
`;

const LogoImage = styled.img`
  max-height: 50px;
`;
